import send from './send';
import clear from './clear';
import clearAll from './clearAll';

import combineActions from '../../utils/combineActions';

export default combineActions({
    send,
    clear,
    clearAll,
});
